import React, { useState, useEffect } from 'react'
import { FiDownload } from 'react-icons/fi'

function ImportBasics(props) {
  const { userDataFromStorage,coloredTheme } = props;



  return (
    <div className={userDataFromStorage.user_role === 'admin' ? 'xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden' : 'xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden'}>
      <p className='text-gray-800 text-[1.8rem] tracking-wider'>Load Import File</p>

      <div className='mt-6 md:flex justify-start items-center md:space-x-8 lg:space-x-0'>
        <p className='lg:w-[25rem]'>Import File</p>
        <div className='flex justify-start items-center lg:flex-grow mt-2 md:mt-0 lg:w-fit md:w-[80%] w-[100%] '>
          <input className='border border-gray-400 rounded px-[0.5rem] h-[2rem]  w-[90%] md:w-[80%] ' type="text" disabled />
          <label style={{ backgroundColor: coloredTheme }} htmlFor='choose' className='ml-2 border h-[2rem] items-center  flex px-[0.8rem]  rounded text-white'>Browse</label>
          <input type="file" id="choose" className='hidden' />
        </div>
      </div>
      <button style={{ backgroundColor: coloredTheme }} className='md:mt-12 mt-8 flex justify-center items-center space-x-2 rounded text-white  px-[1rem] py-[0.5rem]'>
        <FiDownload />
        <p>Import</p>
      </button>
    </div>
  )
}

export default ImportBasics